// extracted by mini-css-extract-plugin
export default {"wrapper":"loading_wrapper__u815U","spinner":"loading_spinner__-+7IQ","rotate":"loading_rotate__pWGBd","path":"loading_path__yK-yQ","dash":"loading_dash__OlS9E"};